import {defineStore} from 'pinia';
import {ModuleBankStandard} from './../moduleConst';
import BankStandardAPI from '@/apis/di/bankStandardAPI';
import {BaseDictionaryStore} from './../baseDictionaryStore';

const BankStandardStore = new BaseDictionaryStore(BankStandardAPI);

export const useBankStandardStore = defineStore(ModuleBankStandard, {
  state: () => ({
    ...BankStandardStore.state,
    _config: {
      key: 'bank_standard_id',
      code: 'bank_code',
      name: 'bank_name',
      table: 'di_bank_standard',
      moduleName: 'Danh mục ngân hàng',
      quickFollow: 'active',
      defaultSort: 'bank_code',
    },
    moduleName: 'bank_standard',
  }),
  actions: {
    ...BankStandardStore.action,
  },
  getters: {
    ...BankStandardStore.getters,

    /**
     * Lấy danh sách ngân hàng (is_open_treasury = false) đang theo dõi
     * @return {Array}
     */
    bankItems() {
      return this.items.filter(x => !x.is_open_treasury && x.active);
    },

    /**
     * Lấy danh sách kho bạc (is_open_treasury = true) đang theo dõi
     * @return {Array}
     */
    treasuryItems() {
      return this.items.filter(x => x.is_open_treasury && x.active);
    },
  },
});
